// SupportSlot (in the header) reserves room for the support launcher and dispatches
// this window event when the slot mounts, resizes or unmounts; messenger.ts re-docks
// on it. Kept apart from messenger.ts so the header does not load the messenger module.
export const SUPPORT_SLOT_SELECTOR = '.support-slot';
export const SUPPORT_SLOT_EVENT = 'outlaw-support-slot';
// messenger.ts dispatches this (a CustomEvent whose detail is a boolean) when the
// pointer or keyboard focus enters or leaves the closed launcher, so SupportSlot
// can show its tooltip.
export const SUPPORT_HOVER_EVENT = 'outlaw-support-hover';
